import { Table as MantineTable } from "@mantine/core";
export function WomensTopsTable() {
  return (
    <MantineTable>
      <MantineTable.Thead>
        <MantineTable.Tr>
          <MantineTable.Th>Size (KURB)</MantineTable.Th>
          <MantineTable.Th>0-5</MantineTable.Th>
          <MantineTable.Th>IT</MantineTable.Th>
          <MantineTable.Th>FR</MantineTable.Th>
          <MantineTable.Th>US</MantineTable.Th>
          <MantineTable.Th>UK</MantineTable.Th>
          <MantineTable.Th>DK</MantineTable.Th>
        </MantineTable.Tr>
      </MantineTable.Thead>
      <MantineTable.Tbody>
        <MantineTable.Tr>
          <MantineTable.Td>XXXXXS</MantineTable.Td>
          <MantineTable.Td>000000</MantineTable.Td>
          <MantineTable.Td>30</MantineTable.Td>
          <MantineTable.Td>26</MantineTable.Td>
          <MantineTable.Td>0000</MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
          <MantineTable.Td>26</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXXS</MantineTable.Td>
          <MantineTable.Td>00000</MantineTable.Td>
          <MantineTable.Td>32</MantineTable.Td>
          <MantineTable.Td>28</MantineTable.Td>
          <MantineTable.Td>00</MantineTable.Td>
          <MantineTable.Td>0</MantineTable.Td>
          <MantineTable.Td>28</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXS</MantineTable.Td>
          <MantineTable.Td>0000</MantineTable.Td>
          <MantineTable.Td>34</MantineTable.Td>
          <MantineTable.Td>30</MantineTable.Td>
          <MantineTable.Td>0</MantineTable.Td>
          <MantineTable.Td>2</MantineTable.Td>
          <MantineTable.Td>30</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXS</MantineTable.Td>
          <MantineTable.Td>000</MantineTable.Td>
          <MantineTable.Td>36</MantineTable.Td>
          <MantineTable.Td>32</MantineTable.Td>
          <MantineTable.Td>1</MantineTable.Td>
          <MantineTable.Td>4</MantineTable.Td>
          <MantineTable.Td>32</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XS</MantineTable.Td>
          <MantineTable.Td>00</MantineTable.Td>
          <MantineTable.Td>38</MantineTable.Td>
          <MantineTable.Td>34</MantineTable.Td>
          <MantineTable.Td>2</MantineTable.Td>
          <MantineTable.Td>6</MantineTable.Td>
          <MantineTable.Td>34</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>S</MantineTable.Td>
          <MantineTable.Td>0</MantineTable.Td>
          <MantineTable.Td>40</MantineTable.Td>
          <MantineTable.Td>36</MantineTable.Td>
          <MantineTable.Td>3</MantineTable.Td>
          <MantineTable.Td>8</MantineTable.Td>
          <MantineTable.Td>36</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>M</MantineTable.Td>
          <MantineTable.Td>1</MantineTable.Td>
          <MantineTable.Td>42</MantineTable.Td>
          <MantineTable.Td>38</MantineTable.Td>
          <MantineTable.Td>4</MantineTable.Td>
          <MantineTable.Td>10</MantineTable.Td>
          <MantineTable.Td>38</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>L</MantineTable.Td>
          <MantineTable.Td>2</MantineTable.Td>
          <MantineTable.Td>44</MantineTable.Td>
          <MantineTable.Td>40</MantineTable.Td>
          <MantineTable.Td>5</MantineTable.Td>
          <MantineTable.Td>12</MantineTable.Td>
          <MantineTable.Td>40</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XL</MantineTable.Td>
          <MantineTable.Td>3</MantineTable.Td>
          <MantineTable.Td>46</MantineTable.Td>
          <MantineTable.Td>42</MantineTable.Td>
          <MantineTable.Td>6</MantineTable.Td>
          <MantineTable.Td>14</MantineTable.Td>
          <MantineTable.Td>42</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXL</MantineTable.Td>
          <MantineTable.Td>4</MantineTable.Td>
          <MantineTable.Td>48</MantineTable.Td>
          <MantineTable.Td>44</MantineTable.Td>
          <MantineTable.Td>8</MantineTable.Td>
          <MantineTable.Td>16</MantineTable.Td>
          <MantineTable.Td>44</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXL</MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
          <MantineTable.Td>50-52</MantineTable.Td>
          <MantineTable.Td>46</MantineTable.Td>
          <MantineTable.Td>10</MantineTable.Td>
          <MantineTable.Td>18-20</MantineTable.Td>
          <MantineTable.Td>46</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXXL</MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
          <MantineTable.Td>54-56</MantineTable.Td>
          <MantineTable.Td>48</MantineTable.Td>
          <MantineTable.Td>12</MantineTable.Td>
          <MantineTable.Td>22</MantineTable.Td>
          <MantineTable.Td>48</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXXXL</MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
          <MantineTable.Td>58</MantineTable.Td>
          <MantineTable.Td>50</MantineTable.Td>
          <MantineTable.Td>14-16</MantineTable.Td>
          <MantineTable.Td>24</MantineTable.Td>
          <MantineTable.Td>50</MantineTable.Td>
        </MantineTable.Tr>
        <MantineTable.Tr>
          <MantineTable.Td>XXXXXXL</MantineTable.Td>
          <MantineTable.Td></MantineTable.Td>
          <MantineTable.Td>60</MantineTable.Td>
          <MantineTable.Td>52</MantineTable.Td>
          <MantineTable.Td>22</MantineTable.Td>
          <MantineTable.Td>26</MantineTable.Td>
          <MantineTable.Td>52</MantineTable.Td>
        </MantineTable.Tr>
      </MantineTable.Tbody>
    </MantineTable>
  );
}
